import type { RootState } from "app/redux/slices/rootReducer";

export const selectIsMenuOpen = (state: RootState) => {
  return state.menuSlice.isMenuOpen;
};

export const selectIsSoundOn = (state: RootState) => {
  return state.menuSlice.isSoundOn;
};
